<div class="row no-gutters justify-content-end">
  <a (click)="remove()" class="close-btn"> × </a>
</div>
<fgb-notification-item [notification]="notification"></fgb-notification-item>
